import React, { useState } from "react"
import { Container } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Trans, useLingui } from "@lingui/react"
import MemberList from "./member-list"
import SearchBar from "./searchBar"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { setCurrentPage, setPreviousPage } from "../../store/reducers/navigation"
import {
  canCashout,
  cashoutStarted,
  getCashoutDetails,
  membersTocashout,
} from "../../store/reducers/cashout/actions"
import CustomModal from "../layout/Modal"
import { toast } from "react-toastify"
import { t } from "@lingui/macro"
import { ErrorMessage } from "../meetings/MeetingsMenu"
import { patchMeeting } from "../../store/actions/meetings/createMeeting"
import { fetchMeeting, meetingLoaded } from "../../store/actions/meetings/getMeeting"
import styles from "./MemberMenu.module.css"

export const SuccessMessage = () => {
  return (
    <div>
      <Trans id="meeting.ended.successfully">Meeting ended successfully</Trans>
    </div>
  )
}

const MemberMenu = (props) => {
  const { i18n } = useLingui()
  const notify = (msg) => toast.info(msg)
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [filterMembers, setFilterMembers] = React.useState([])

  React.useEffect(() => {
    setFilterMembers(props.members)
  }, [props.members])

  const performCashOut = async () => {
    const hasLoan = await props.canCashout()
    if (hasLoan.length) {
      props.setPage("group-cashOutError")
      return
    }
    if (props.membersTocashout.length) {
      props.setPage("group-endOfCycleCashout")
    } else {
      const members = props.members.filter(
        (member) =>
          member.status === "Active" && member.blockchain_wallet_id !== null,
      )
      props.setMembersTocashout(members)
      props.cashoutStarted(true)
      props.setPage("group-endOfCycleCashout")
    }
  }

  const [modalInputData, setInputData] = useState()

  const endMeeting = () => {
    const lang_code = i18n.locale
    const meeting = props.meeting?.ongoing

    const group_name = props.group?.name

    const notif = {
      en: {
        message: `The secretary has ended a meeting for ${group_name} group on VSLA Online`,
      },
      fr: {
        message: `FRA - The secretary has ended a meeting for ${group_name} group on VSLA Online`,
      },
      sw: {
        message: `SWA - The secretary has ended a meeting for ${group_name} group on VSLA Online`,
      },
      es: {
        message: `La secretaria ha terminado una reunión para el grupo ${group_name} en VSLA Online`,
      },
      lb: {
        message: `The officer has ended a session for ${group_name} community on VSLA.online`,
      },
      ar: {
        message: group_name,
      },
      pt: {
        message: `O/A secretário/a iniciou uma reunião para o grupo ${group_name} no VSLA Online`,
      },
    }

    const data = {
      date: meeting.date,
      status: "completed",
      group_id: meeting.group_id,
      msg: Object.values(notif[lang_code])[0],
    }
    props
      .patchOngoingMeeting(data)
      .then(() => {
        setLoading(false)
        notify(<SuccessMessage />)
      })
      .catch(() => {
        notify(<ErrorMessage />)
      })
  }

  React.useEffect(() => {
    if (
      props.meeting?.ongoing &&
      props.previousPage === "group-endOfCycleCashout" &&
      !props.cashoutActive
    ) {
      const cashoutCompleted = props.group?.can_change_share_value

      if (cashoutCompleted) {
        props.setPreviousPage(null)
        setLoading(true)
        endMeeting()
        props.setPage("group-meetingsMenu")
        return
      }
    }
  }, [props.group?.can_change_share_value])

  const addMembers = () => {
    props.setPage("group-addMemberMenu")
  }

  const triggerCashout = () => {
    if (
      props.hasOfflineTransactions ||
      props.members.some((m) => ["pending", "error"].includes(m?.syncStatus))
    ) {
      alert(i18n._("Cannot cash out while offline transactions are pending"))
      return
    } else setIsOpen(true)
  }

  return (
    <div>
      <Container>
        <div onClick={addMembers} className={styles.menuItem}>
          <span className={styles.menuLabel}>
            <Trans id="Add Member">Add Member</Trans>
          </span>
          <FontAwesomeIcon className={styles.menuIcon} icon="angle-right" />
        </div>
        <SearchBar setter={setFilterMembers} data={props.members} />
        {props.cashoutData &&
          props.cashoutData.hasBalances &&
          props.cashoutData.hasMembers &&
          props.meeting?.ongoing &&
          !["ar", "lb"].includes(i18n.locale) && (
            <div onClick={triggerCashout} className={styles.menuItem}>
              <span className={styles.menuLabel}>
                <Trans id="End of Cycle Cash Out">End of Cycle Cash Out</Trans>
              </span>
              <FontAwesomeIcon className={styles.menuIcon} icon="angle-right" />
            </div>
          )}
        <CustomModal
          modalHeader={i18n._("Warning")}
          headerClassName="d-flex justify-content-center"
          bodyContent={
            <div>
              {t({
                id: `Warning: This will cash out all the member's funds from the group. This action cannot be undone.`,
              })}
              <br />
              <br />
              <Trans
                id="To proceed, type &quot;{confirmWord}&quot; in the box below and click continue"
                values={{ confirmWord: <Trans id="Cashout">Cashout</Trans> }}
              />
            </div>
          }
          isCentered={true}
          showInput={true}
          errors={{}}
          showSavingsCycle={false}
          isCashoutModal={true}
          setInputData={setInputData}
          isOpen={isOpen}
          footerContent={
            <div className="btn-toolbar">
              <button
                onClick={() => {
                  setIsOpen(false)
                }}
                className={styles.backButton}
              >
                {i18n._("Back")}
              </button>
              <button
                disabled={
                  !(
                    modalInputData?.toLocaleLowerCase() ===
                    i18n._({id: "Cashout", message: "Cashout"})?.toLocaleLowerCase()
                  )
                }
                onClick={() => performCashOut()}
                className={styles.continueButton}
              >
                {i18n._("Continue")}
              </button>
            </div>
          }
        />
        {loading && (
          <span
            className="dots-loader"
            style={{
              color: "#E36F1E",
              fontSize: 12,
              margin: "auto",
            }}
          >
            {i18n._("Processing")}
            <span style={{ position: "absolute" }}></span>
          </span>
        )}
      </Container>
      <MemberList id={props.group?.id} filterMembers={filterMembers} />
    </div>
  )
}

MemberMenu.propTypes = {
  canCashout: PropTypes.func,
  membersTocashout: PropTypes.array,
  setPage: PropTypes.func,
  members: PropTypes.array,
  setMembersTocashout: PropTypes.func,
  cashoutStarted: PropTypes.func,
  vsla: PropTypes.object,
  user: PropTypes.object,
  group: PropTypes.object,
  clearMeetingLoaded: PropTypes.func,
  patchOngoingMeeting: PropTypes.func,
  fetchOngoingMeeting: PropTypes.func,
  previousPage: PropTypes.string,
  cashoutActive: PropTypes.bool,
  setPreviousPage: PropTypes.func,
  cashoutData: PropTypes.object,
  isConnected: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    isConnected: state.isConnected,
    vsla: state.vsla,
    group: state.group,
    members: state.loadedvslaMembers,
    cashoutData: state.loadingCashoutData.loadingCashoutData,
    membersTocashout: state.membersTocashout,
    meeting: state.meeting,
    loadedvslaMembers: state.loadedvslaMembers,
    user: state.user,
    previousPage: state.previousPage,
    cashoutActive: state.cashoutStarted,
    hasOfflineTransactions:
      state.accountV2.offline &&
      Object.keys(state.accountV2.offline?.transactions).length,
  }
}

const mapDispatchToProps = (dispatch) => ({
  setPage: (page) => dispatch(setCurrentPage(page)),
  cashoutStarted: (state) => dispatch(cashoutStarted(state)),
  getCashoutDetails: () => dispatch(getCashoutDetails()),
  setMembersTocashout: (members) => dispatch(membersTocashout(members)),
  canCashout: () => dispatch(canCashout()),
  clearMeetingLoaded: () => dispatch(meetingLoaded([])),
  patchOngoingMeeting: (data) => dispatch(patchMeeting(data)),
  fetchOngoingMeeting: () => dispatch(fetchMeeting()),
  setPreviousPage: (page) => dispatch(setPreviousPage(page)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MemberMenu)
